import { helpers } from '@vuelidate/validators';
import { toPositiveOptionId } from '@/utils/optionValues';
import { SALES_TEXT } from '@/texts/catalog/sales';

const VALIDATION_TEXT = SALES_TEXT.modal.validation;

export const saleModalValidations = function saleModalValidations() {
  return {
    form: {
      saleName: {
        required: helpers.withMessage(
          VALIDATION_TEXT.saleNameRequired,
          (value) => String(value || '').trim() !== ''
        ),
      },
      service: {
        required: helpers.withMessage(
          VALIDATION_TEXT.serviceRequired,
          (value) => toPositiveOptionId(value) > 0
        ),
      },
      customer: {
        requiredForSingle: helpers.withMessage(
          VALIDATION_TEXT.customerRequired,
          (value) => {
            if (this.isMultiCustomerMode) {
              return true;
            }

            return toPositiveOptionId(value) > 0;
          }
        ),
      },
      customers: {
        requiredForMulti: helpers.withMessage(
          VALIDATION_TEXT.customersRequired,
          (value) => {
            if (!this.isMultiCustomerMode) {
              return true;
            }

            const selectedCustomers = (Array.isArray(value) ? value : [])
              .map((customer) => toPositiveOptionId(customer))
              .filter((id) => id > 0);

            return selectedCustomers.length > 0;
          }
        ),
      },
      paymentsCount: {
        validRecurringCount: helpers.withMessage(
          VALIDATION_TEXT.paymentsCountRequired,
          () => {
            if (!this.isFlatRateMode) {
              return true;
            }

            return Number(this.form?.paymentsCount || 0) > 0;
          }
        ),
      },
      firstInstallmentOption: {
        requiredForMonthly: helpers.withMessage(
          VALIDATION_TEXT.firstInstallmentRequired,
          (value) => {
            if (!this.isFlatRateMode) {
              return true;
            }

            const frequency = String(this.form?.frequency || '').trim().toLowerCase();
            if (frequency !== 'monthly') {
              return true;
            }

            return String(value?.value || '').trim() !== '';
          }
        ),
      },
      periodicityOption: {
        requiredForMultiple: helpers.withMessage(
          VALIDATION_TEXT.periodicityRequired,
          (value) => {
            if (!this.isFlatRateMode) {
              return true;
            }

            const frequency = String(this.form?.frequency || '').trim().toLowerCase();
            if (frequency !== 'multiple') {
              return true;
            }

            return String(value?.value || '').trim() !== '';
          }
        ),
      },
    },
  };
};
